export default "__VITE_ASSET__Csnmg2Pn__"